import { LazyLoader, Modal } from '@bp/ui-components';
import { FragmentType } from 'client/gql';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GroupEditorsForm, GroupEditorsFormFragment } from '../forms/GroupEditorsForm';

type GroupEditorsModalProps = {
  isOpen: boolean;
  groupUuid: string;
  schoolYearUuid: string;
  onClose: () => void;
  query: FragmentType<typeof GroupEditorsFormFragment> | undefined;
};

export const GroupEditorsModal = ({ isOpen, groupUuid, schoolYearUuid, onClose, query }: GroupEditorsModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal loading={loading} isOpen={isOpen} onRequestClose={onClose} title={t('groups.editEditors')}>
      <Suspense fallback={<LazyLoader embedded forceHeight='58vh' />}>
        <GroupEditorsForm
          query={query}
          groupUuid={groupUuid}
          schoolYearUuid={schoolYearUuid}
          onLoad={setLoading}
          onClose={onClose}
        />
      </Suspense>
    </Modal>
  );
};
